import { ProductImages } from "modules/product/types/product";
import { AddCartMethod } from "modules/cart/types/add-cart-methods";
import { ProductUpdates } from "modules/product/types/updates";
import { ProductDecision } from "modules/checkout/types/productDecission";

enum CartActionType {
  AddDeletefromCart = "AddToCart",
  RemoveFromCart = "RemoveFromCart",
  ClearCart = "ClearCart",
  Recalculate = "Recalculate",
  ReplaceCart = "ReplaceCart",
  Validating = "Validating",
  RefreshCart = "RefreshCart",
  SetDecision = "SetDecision",
}

interface CartItem {
  id: string;
  brand: string;
  slug: string;
  name: string;
  category_id: number;
  met_conditions?: boolean;
  price_component: Array<PriceComponent>;
  method: AddCartMethod;
  productDecision?: ProductDecision;
  /** True while needing product search/re-selection */
  is_pending_resolution?: boolean;
  /** True when the product was AI-resolved from a shopping list execution.
   *  Switches the cart card CTA from "¿Si no hay stock?" → "¿no es lo que buscas?"
   *  to launch ProductSearchPicker for replacement. */
  is_ai_resolved?: boolean;
  /** Original user-provided description from list execution (free text).
   *  Used as initialQuery in the "¿no es lo que buscas?" search picker. */
  raw_description?: string;
}

interface PriceComponent {
  id: number;
  sku: string;
  name: string;
  image_url: string;
  images: ProductImages;
  url: string;
  quantity: number;
  price: number;
  worst_price: number;
  no_promo_price: number;
  is_promo: boolean;
  has_alternatives: boolean;
  no_met_conditions?: boolean;
  factor?: number;
  replaced_url?: string;
  replaced_image_url?: string;
  replaced_images?: ProductImages;
  replaced_slug?: string;
  replaced_sku?: string;
  replaced_name?: string;
  replaced_price?: number;
}

interface DecisionPayload {
  id: string;
  productDecision: ProductDecision;
}

interface Action {
  type: CartActionType;
  payload?: Payload | ReplaceCartPayload | CartItem[] | DecisionPayload;
}

interface Payload {
  id: string;
  sku: string;
  name?: string;
  category_id: number;
  quantity: number;
  method?: AddCartMethod;
  /** Canonical hashed SKU for catalog linking */
  hashedSku?: string | null;
  /** Store-level product ID for analytics */
  s_id?: number;
  /** Marks the cart item as AI-resolved from a list execution */
  is_ai_resolved?: boolean;
  /** Original user-provided text from list execution */
  raw_description?: string;
}

interface ReplaceCartPayload {
  cart: Array<CartItem>;
}

interface DispatchAction {
  type: CartActionType;
  payload?: CartMessageAction | DecisionPayload;
  payloadArray?: CartItem[];
}

interface CartMessageAction {
  product?: CartItem;
  cart?: Array<CartItem>;
}

interface ValidationConflict {
  isOpen: boolean;
  productUpdates?: ProductUpdates;
}

export type {
  CartItem,
  PriceComponent,
  Action,
  DispatchAction,
  Payload,
  ReplaceCartPayload,
  ValidationConflict,
  DecisionPayload,
};

export { CartActionType };

